import { URLS } from "../config";
import { logoutHandler } from "./logoutHandler";
import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";

export const createOrder = async (
  data: { items: any[] },
  token: string,
  dispatch: Dispatch,
  navigate: NavigateFunction
) => {
  const response = await fetch(URLS.ORDER_SUBMIT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `JWT ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (response.status === 401) {
    logoutHandler(dispatch, navigate); // خروج از سیستم و ریدایرکت به login
    return;
  }

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'خطا در ثبت سفارش');
  }

  return await response.json();
};